// src/models/caixas/Caixa.js
export class Caixa {
    aberto = false;

    constructor(id, filialId, descricao = "", aberto = false, filial) {
      this.id = id;
      this.filialId = filialId;
      this.descricao = descricao;
      this.aberto = aberto;
      this.filial = filial || null;
    }
  }
